import React from "react";
import "./LMSButton.css";

const variantStyles = {
  primary: {
    backgroundColor: "var(--green3-color)", //#1a7a73 green colored button for tableheader and addButtonLabel
    color: "#fff",
  },
  secondary: {
    backgroundColor: "var(--grey-color)", //#979797 grey colored button
    color: "var(--white-font-color)",
  },
  success: {
    backgroundColor: "var(--green2-color)", //#1a7a73 used for submit button green type
    color: "var(--white-font-color)",
  },
  active: {
    backgroundColor: "var(--active-color)", //#1a7a73 used for submit button green type
    color: "var(--white-font-color)",
  },
  success2: {
    backgroundColor: "var(--green2-text-color)", //#007934 mostly used for whitelist button
    color: "var(--white-font-color)",
  },
  warning: {
    backgroundColor: "var(--active-color)", //#ffa100
    color: "var(--white-font-color)",
  },
  danger: {
    backgroundColor: "var(--red-color)", //#E95060 mostly used for blacklist button
    color: "var(--white-font-color)",
  },
  light: {
    backgroundColor: "var(--white-font-color)", //#E95060 mostly used for blacklist button
    color: "var(--black-color)",
  },
};

const LMSButton = ({
  label, //mandatory
  onClick, //mandatory
  key = "",
  className = "",
  type = "button",
  style = {},
  customId,
  disabled = false,
  variant = "primary",
  size = "btn_lg", //.btn_sm,btn_xlg,btn_vsm,btn_vvsm
  href = null,
  ref,
  scrollToTop = false,
  buttonEffect = false,
  ...restOfProps
}) => {
  const buttonStyle = {
    ...variantStyles[variant],
    ...style,
    opacity: disabled ? 0.8 : 1,
  };
  const effectClass = buttonEffect ? "effect" : "";
  if (href) {
    return (
      <a
        href={href}
        type={type}
        key={key}
        style={buttonStyle}
        className={`lms_btn ${size} ${className} ${variant}`}
        {...restOfProps}>
        {label}
      </a>
    );
  }

  return (
    <>
      <button
        type={type}
        key={key}
        onClick={onClick}
        style={buttonStyle}
        disabled={disabled}
        id={customId}
        ref={ref}
        className={`lms_btn ${size} ${className} ${variant} ${effectClass}`}
        {...restOfProps}>
        {label}
      </button>
    </>
  );
};

export default LMSButton;
